import * as React from 'react';
import './nav.css';

import * as logo from '../assets/logo/2018_logo_simple_light.svg';
import Button from '../custom_components/button/button.component';
import { Link, withRouter } from 'react-router-dom';
import ButtonLink from '../custom_components/button_link/button_link.component';
import { StoreState, CustomAction } from '../store';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectGeneric } from '../store/actions/generic.actions';
import { History } from 'history';

export interface Nav_Props {
    route: string;

    navTo: Function;
}

class Nav extends React.PureComponent<Nav_Props> {

    render() {
        const Submit_Button = withRouter(
            ({history}) => (
                <Button 
                    onClick={this.getStarted.bind(this, history)} 
                    disabled={false}
                    text="Get Started" 
                    color="#4876ff"
                    text_color="white">
                </Button>
            )
        )

        return (
            <div className="nav-main">
                <div className="nav-logo-name">
                    <Link onClick={() => this.navTo('/')} to="/">
                        <img src={logo} className="nav-logo" alt="logo" />
                    </Link>
                    <span className="nav-name">OneClick HRM</span>
                </div>
                <div className="nav-links">
                    <ButtonLink className="button-override" to="/" text="Home" color="white" text_color="rgba(0,0,0,0.75)"></ButtonLink>
                    <ButtonLink className="button-override" to="/pricing" text="Pricing" color="white" text_color="rgba(0,0,0,0.75)"></ButtonLink>
                    {/* <ButtonLink className="button-override" to="/signup" text="Signup" color="white" text_color="rgba(0,0,0,0.75)"></ButtonLink> */}
                </div>
                <div className="nav-button">
                    <Submit_Button></Submit_Button>
                </div>
            </div>
        )
    }


    navTo(_to: string) {
        this.props.navTo('ROUTE_SELECT', _to)
    }

    getStarted = (history: History, event: any) => {
        // let fresh_details: Signup_Details_Obj = {
        //     email: this.props.signup_form.value,
        //     product: null
        // };

        // this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

        history.push('/signup')
    }
}

export function mapStateToProps({ route }: StoreState) {
    return {
      route: route,
    }
}
  
export function mapDispatchToProps(dispatch: Dispatch<CustomAction>) {
    return bindActionCreators({
        navTo: selectGeneric
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Nav);


// WEBPACK FOOTER //
// ./src/nav/nav.component.tsx